import { ReactElement } from 'react';
import { Typography, Box } from '@mui/material';
import { Doughnut as DoughnutChart } from 'react-chartjs-2';

import LoadingFallback from '~components/LoadingFallback';

import { useReportsVisitsSectionContext } from '../../Context';

import { ReportsVisitsSectionChartsWrapperChart } from '../styles';

import { getReasonsForIncompleteVisitsChartProps } from './utils';

const ReportsVisitsSectionChartsReasonsForIncompleteVisits =
  (): ReactElement => {
    const {
      data: {
        summary: { data: summaryData, loading: loadingSummaryData },
      },
    } = useReportsVisitsSectionContext();

    return (
      <ReportsVisitsSectionChartsWrapperChart>
        <Typography variant="body1" component="h4" fontWeight="bold">
          Motivos de visitas incompletas
        </Typography>

        {loadingSummaryData && <LoadingFallback />}

        {!loadingSummaryData && summaryData && (
          <Box maxHeight={302}>
            <DoughnutChart
              {...getReasonsForIncompleteVisitsChartProps(
                summaryData.reportRouteSummaryEvidence,
              )}
            />
          </Box>
        )}
      </ReportsVisitsSectionChartsWrapperChart>
    );
  };

export default ReportsVisitsSectionChartsReasonsForIncompleteVisits;
